// LoadingIcon.js
import React from 'react';
import PropTypes from 'prop-types';

import MetriqLoaderSVG from './LoadingIcon/MetriqLoaderSVG';

function LoadingIcon({ size = 150, label = "Loading...", showText = false }) {
  // Calculate font size and image size as a fraction of the container size
  const fontSize = size / 6;
  const imageSize = size / 3;

  const containerStyle = {
    width: `${size}px`,
    height: `${size}px`,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const labelStyle = {
    fontSize: `${fontSize}px`,
    paddingTop: 5
  };

  return (
    <div data-testid="loadingIcon" style={containerStyle}>
      <MetriqLoaderSVG
        size={imageSize}
      />
      {showText && <div data-testid="li-text" style={labelStyle} className='metriq-loading-text'>{label}</div>}
    </div>
  );
}

LoadingIcon.propTypes = {
  size: PropTypes.number,
  label: PropTypes.string,
  showText: PropTypes.bool,
};

export default LoadingIcon;